// extracted by mini-css-extract-plugin
export default {"header":"Navigation_header__iKEbG","active":"Navigation_active__sqspr"};